import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
// import AddMaster from "./AddMaster";
// import EditMaster from "./EditMaster";
// import { adminMainUrl } from '../../../Config';
// import { DesignationApi } from '../../../Redux/action/MasterAction';
import { Code } from '@mui/icons-material';
import ReactTooltip from 'react-tooltip';
import { adminMainUrl } from '../../../../../Config';
import { DesignationApi } from '../../../../../Redux/action/MasterAction';
import AddBillingModal from '../Modal/AddBillingModal';
import EditBillingModal from '../Modal/EditBillingModal';
// import { DesignationApi } from '../../../../Redux/action/MasterAction';
// import { adminMainUrl } from '../../../../Config';

const GeneralBilling = ({ accessedModules, accessedPermission }) => {
    const CurrOpt = [{ value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },];
    const navigate = useNavigate()
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [dataOffset, setDataOffset] = useState(0);
    const dataPerPage = 10;
    const [reload, setReload] = useState(false);
    const [spinnerLoader, setSpinnerLoader] = useState(false)
    const [DesignationName, setDesignationName] = useState(null)
    const [DesignationId, setDesignationId] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Number of items per page
    // const { name } = useParams();
    const [editShow, setEditShow] = useState(false);
    const handleEditClose = () => setEditShow(false);
    const handleEditShow = () => setEditShow(true);
    const dispatch = useDispatch();
    const {
        loadingDesignationTypeApi,
        findDesignationTypeData,
        findDesignationTypeDataError,

    } = useSelector(state => state?.MasterReducer);
    useEffect(() => {
        dispatch(DesignationApi(adminMainUrl));
    }, [adminMainUrl, reload]);
    const handleSuccess = () => {
        // Toggle reload to trigger useEffect
        setReload(prev => !prev);
    };

    // Initialize Formik
    const statusChange = async (id) => {
        setSpinnerLoader(true)
        try {
            const response = await fetch(`${adminMainUrl}/api/designation/status-change`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
                },
                body: JSON.stringify({ id: id.toString() }),
            });

            const data = await response.json();

            if (response.ok) {
                setSpinnerLoader(false)
                handleSuccess(); // Call the success handler
                toast.success(data?.msg);
            } else {
                setSpinnerLoader(false)
                toast.error(data?.msg);
            }
        } catch (error) {
            setSpinnerLoader(false)
            console.error('Network error:', error);
        }
    };

    const handleChange = (id) => {
        // if (accessedPermission.includes("state_change_master_data")) {
        statusChange(id);
        // }
    };
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = findDesignationTypeData?.data

    const totalPages = Math.ceil(findDesignationTypeData?.data?.length / itemsPerPage);

    // Function to change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Function for "Next" and "Previous" buttons
    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const arr = new Array(5).fill(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    }
    // const columns = [
    //     { title: "Request No.", dataIndex: "requestNo", key: "requestNo" },
    //     { title: "Date", dataIndex: "date", key: "date" },
    //     { title: "Name", dataIndex: "name", key: "name" },
    //     { title: "Email", dataIndex: "email", key: "email" },
    //     { title: "Phone Number", dataIndex: "phoneNumber", key: "phoneNumber" },
    //     { title: "Origin", dataIndex: "origin", key: "origin" },
    //     { title: "Destination", dataIndex: "destination", key: "destination" },
    //     { title: "Shipment Type", dataIndex: "shipmentType", key: "shipmentType" },
    //     { title: "Shipment Via", dataIndex: "shipmentVia", key: "shipmentVia" },
    //     { title: "Picked By", dataIndex: "pickedBy", key: "pickedBy" },
    //     { title: "Action", dataIndex: "action", key: "action" },
    // ];

    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Bill Types", dataIndex: "BillTypes", key: "BillTypes" },
        { title: "Due After", dataIndex: "DueAfter", key: "DueAfter" },
        { title: "Bill To", dataIndex: "BillTo", key: "BillTo" },
        { title: "Organization", dataIndex: "Organization", key: "Organization" },
        { title: "Club Charges", dataIndex: "ClubCharges", key: "ClubCharges" },
        { title: "Action", dataIndex: "action", key: "action" },

    ];

    const dataSource = [{
        key: "1", // Add a unique key for each row
        SNo: "1", // Changed to camelCase
        BillTypes: "BillTypes", // Ensure date formatting as neede
        DueAfter: "DueAfter",
        BillTo: "Applicable",
        Organization: "Charge",
        ClubCharges: "AE",
        action: (
            <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                    <div className="dropdown-item cursor-pointer" onClick={
                        handleEditShow
                    }>
                        <i className="ti ti-edit text-blue me-2"></i> Edit
                    </div>
                    <div className="dropdown-item cursor-pointer" >
                        <i className="ti ti-trash text-danger me-1"></i> Delete
                    </div>

                </div>
            </div>
        )
    },
    {
        key: "1", // Add a unique key for each row
        SNo: "1", // Changed to camelCase
        BillTypes: "BillTypes", // Ensure date formatting as neede
        DueAfter: "DueAfter",
        BillTo: "Applicable",
        Organization: "Charge",
        ClubCharges: "AE",
        action: (
            <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                    <div className="dropdown-item cursor-pointer" onClick={
                        handleEditShow
                    }>
                        <i className="ti ti-edit text-blue me-2"></i> Edit
                    </div>
                    <div className="dropdown-item cursor-pointer" >
                        <i className="ti ti-trash text-danger me-1"></i> Delete
                    </div>

                </div>
            </div>
        )

    },]
    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => setAddShow(false);
    const handleAddShow = () => setAddShow(true);

    

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    {/* Page Header */}
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">
                                    Default Bill Types
                                </h4>
                            </div>

                        </div>
                    </div>
                    {/* /Page Header */}
                </div>
            </div>
            <div className="card">

                <div className="card-body">

                    {/* Filter */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 mb-3">
                            <label className='form-label me-3'>
                                Default Currency
                            </label>
                            <div className="icon-form mb-3 mb-sm-0">
                                <Select

                                    className='custom-selector'
                                    options={CurrOpt}
                                // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                            </div>

                        </div>
                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                            <div
                                onClick={handleAddShow}
                                className="btn btn-primary cursor-pointer me-2"
                            >
                                New
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive custom-table">
                        <Table className="table datanew dataTable no-footer" pagination={false}
                            dataSource={dataSource} columns={columns} />
                    </div>
                </div>
            </div>
            <div className="row justify-content-end mt-3 gap-2">
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save & Close
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save & New
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Close
                </button>

            </div>
            <AddBillingModal show={addShow} handleClose={handleAddClose} />
            <EditBillingModal show={editShow} handleClose={handleEditClose} />
        </>

    )
}

export default GeneralBilling